export default __webpack_public_path__ + "static/media/list6.56a0abe2.png";